import React, { type FunctionComponent } from 'react'
import { Text } from '@retailer-platform/shared-components'
import { type DomainMessages, useDomainMessage } from 'domains/collections/utils/domain/intl'

interface Props {
  labelId: DomainMessages
  width?: number
}

export const CollectionsViewInfo: FunctionComponent<Props> = ({
  labelId,
  children,
  width = 375,
}) => {
  const label = useDomainMessage(labelId)

  return (
    <div css={{ width }}>
      <Text size="medium" weight="semibold">
        {label}
      </Text>
      {children}
    </div>
  )
}
